import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ListItem,
  ListItemText
} from '@mui/material'
import { FC, useMemo } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useListCannedJobsQuery } from '../../../redux/api/cannedJobApi'
import { useGetIntakeRequestsQuery } from '../../../redux/api/customerFormsApi'
import { CannedJobExpanded } from '../../../sdk'
import {
  ModifiedCannedJobExpanded,
  SelectedJob
} from '../../Estimates/useLookupServiceDialog/transformSelectedJob'

interface Props {
  repairOrderId: string
  selected: SelectedJob
  setSelected: (s: SelectedJob) => void
  cannedJobsExpanded: CannedJobExpanded[] | undefined
}

const CannedJobSelectionInfoPanel: FC<Props> = ({
  repairOrderId,
  selected,
  setSelected,
  cannedJobsExpanded
}) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { data: intakeRequests } = useGetIntakeRequestsQuery({
    authorization: accessToken,
    repairOrderId
  })
  const associatedRequest = intakeRequests && intakeRequests[0]

  const requestCannedJobs = associatedRequest?.cannedJobs

  const { data: shopCannedJobs } = useListCannedJobsQuery({
    authorization: accessToken,
    shop: shopId
  })

  const filteredCannedJobs = useMemo(() => {
    if (shopCannedJobs && requestCannedJobs) {
      return shopCannedJobs.filter((job) => requestCannedJobs.includes(job.id!))
    }
    return null
  }, [shopCannedJobs, requestCannedJobs])

  const handleSelectCannedJobs = () => {
    const intakeCannedJobIds = new Set(
      (filteredCannedJobs || []).map((entry) => entry.id!)
    )
    const modifiedCannedJobs: ModifiedCannedJobExpanded[] = (
      cannedJobsExpanded || []
    )
      .filter((expanded) => intakeCannedJobIds.has(expanded.entry!.id!))
      .map((expanded) => ({
        ...expanded,
        unSelected: new Set<string>()
      }))
    setSelected({
      ...selected,
      canned: modifiedCannedJobs
    })
  }

  return (
    <>
      {filteredCannedJobs &&
      filteredCannedJobs.length > 0 &&
      cannedJobsExpanded ? (
        <Box sx={{ mb: 2 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Customer has requested {filteredCannedJobs.length} canned job
              {filteredCannedJobs.length === 1 ? '' : 's'} for this vehicle.
            </AccordionSummary>
            <AccordionDetails>
              {filteredCannedJobs.map((job) => (
                <ListItem key={job.id}>
                  <ListItemText
                    primary={job.info!.name!}
                    secondary={job.info!.shortCode}
                  />
                </ListItem>
              ))}
            </AccordionDetails>
            <AccordionActions>
              <Button onClick={handleSelectCannedJobs} variant="contained">
                Select Canned Jobs
              </Button>
            </AccordionActions>
          </Accordion>
        </Box>
      ) : (
        <></>
      )}
    </>
  )
}

export default CannedJobSelectionInfoPanel
